
import { Vue, Component, Prop } from "vue-property-decorator";
import DELETE_CONTRACTOR_NOTE from "@/apollo/contractors/DeleteContractorNote.gql";

import BasicNoteCard from "@/components/card/BasicNoteCardNew.vue";
import EditNotesModal from "../common/EditNotesModalNew.vue";

import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import UiButton from "@/components/button/ui-button.vue";
import getFullName from "@/helpers/getFullName";

@Component({
  components: {
    UiButton,
    BasicNoteCard,
    EditNotesModal,
  },
})
export default class ContractorNoteCard extends Vue {
  @Prop({ type: String, required: true }) readonly firstName!: string;
  @Prop({ type: String, required: true }) readonly lastName!: string;
  @Prop({ type: String, default: undefined }) readonly jobTitle!: string;
  @Prop({ type: String, default: undefined }) readonly location!: string;
  @Prop({ type: String, default: undefined }) readonly avatar?: string;
  @Prop({ type: String, default: undefined }) readonly note!: string;
  @Prop({ type: String, required: true }) readonly id!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly createdById!: string;
  @Prop({ type: String, default: undefined }) openDate?: string;
  showEditTemplate: boolean = false;
  editModal: boolean = false;

  created(): void {
    if (this.currentUserId == this.createdById) {
      this.showEditTemplate = true;
    }
  }
  removeNote(): void {
    this.$confirm({
      title: `Delete note`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          this.removeManagerNoteToContractor();
        }
      },
    });
  }
  editNote(): void {
    this.editModal = true;
  }

  closeEdit(): void {
    this.editModal = false;
  }

  editNotesToContractors(): void {
    this.$emit("noteWasEditted");
  }

  async removeManagerNoteToContractor(): Promise<void> {
    try {
      await this.removeNoteForContractor();

      this.$emit("noteWasDeleted");
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`Note  was deleted`)
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }

  removeNoteForContractor() {
    return this.$apollo.mutate({
      mutation: DELETE_CONTRACTOR_NOTE,
      variables: {
        id: this.id,
      },
    });
  }
}
